import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const BaselinesStore = {
  namespaced: true,
  state: {
    projectBaselines: {},
    projectBaselineData: {},
    enabledBaselines: {},
  },
  mutations,
  actions,
  getters,
};

export default BaselinesStore;
